import {
  SchoolCandidate,
  OibServiceResult,
  ServiceResultStatus,
} from "../../../models";

export const mapOibDataToSchoolCandidate = (
  currentSchoolCandidate: SchoolCandidate,
  oibData: OibServiceResult<SchoolCandidate>
): SchoolCandidate => {
  if (!oibData.item) {
    return currentSchoolCandidate;
  }

  const {
    firstName,
    lastName,
    dateOfBirth,
    genderId,
    motherName,
    fatherName,
    residence,
  } = oibData.item;

  const uoguCountyId =
    currentSchoolCandidate.uoguCountyId !== 0
      ? currentSchoolCandidate.uoguCountyId
      : oibData.item?.residence?.temporaryAddress?.countyId ??
        oibData.item?.residence?.permanentAddress?.countyId;

  const schoolCandidate: SchoolCandidate = {
    ...currentSchoolCandidate,
    isOibConnected: oibData.status === ServiceResultStatus.Success,
    firstName,
    lastName,
    dateOfBirth,
    genderId,
    motherName,
    fatherName,
    residence,
    uoguCountyId: uoguCountyId ?? 0,
    alternativeCode: null,
    schoolCandidateAlternativeCodeReasonId: null,
    schoolCandidateAlternativeCodeTypeId: null,
  };

  return schoolCandidate;
};
